import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { Sun } from '../components/Icons';

export default function ChangePassword() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw]         = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [err, setErr]   = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const isFirstLogin = user?.must_change_password;

  const submit = async e => {
    e.preventDefault(); setErr(''); setBusy(true);
    if (newPw !== confirmPw) { setErr('New passwords do not match.'); setBusy(false); return; }
    if (newPw.length < 6)    { setErr('Password must be at least 6 characters.'); setBusy(false); return; }
    try {
      await authApi.changePassword({ current_password: isFirstLogin ? '' : currentPw, new_password: newPw });
      setDone(true);
      setTimeout(() => navigate('/dashboard'), 1800);
    } catch (ex) {
      const d = ex.response?.data?.detail;
      setErr(Array.isArray(d) ? d.map(x => x.msg).join(', ') : (d || 'Failed to change password.'));
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', fontFamily: 'Inter,sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 52, height: 52, background: 'var(--navy)', borderRadius: 14, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, boxShadow: '0 4px 12px rgba(26,39,68,.3)' }}>
            <Sun s={24} color="#fff"/>
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 4 }}>
            {isFirstLogin ? 'Set Your Password' : 'Change Password'}
          </div>
          <div style={{ fontSize: 13, color: 'var(--text2)' }}>
            {isFirstLogin
              ? 'For security, you must set a new password before continuing.'
              : 'Enter your current and new password below.'}
          </div>
        </div>

        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: 32, boxShadow: 'var(--shadow-md)' }}>
          {done ? (
            <div className="notice n-ok" style={{ textAlign: 'center', padding: 20, fontSize: 14 }}>
              ✓ Password changed successfully! Redirecting…
            </div>
          ) : (
            <>
              {isFirstLogin && (
                <div className="notice n-warn" style={{ marginBottom: 16, fontSize: 13 }}>
                  This is your first login. Please set a new password to continue.
                </div>
              )}
              {err && (
                <div className="notice n-err" style={{ marginBottom: 14 }}>{err}</div>
              )}
              <form onSubmit={submit}>
                {!isFirstLogin && (
                  <div className="fg" style={{ marginBottom: 14 }}>
                    <label>Current Password</label>
                    <input type="password" value={currentPw} onChange={e => setCurrentPw(e.target.value)} required placeholder="Enter current password" autoFocus/>
                  </div>
                )}
                <div className="fg" style={{ marginBottom: 14 }}>
                  <label>New Password</label>
                  <input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} required placeholder="Minimum 6 characters" autoFocus={isFirstLogin}/>
                </div>
                <div className="fg" style={{ marginBottom: 22 }}>
                  <label>Confirm New Password</label>
                  <input type="password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} required placeholder="Re-enter new password"/>
                </div>
                <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '11px 0', fontSize: 14 }} disabled={busy}>
                  {busy ? 'Changing…' : 'Change Password'}
                </button>
                {!isFirstLogin && (
                  <button type="button" className="btn" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} onClick={() => navigate(-1)}>
                    Cancel
                  </button>
                )}
              </form>
            </>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 14, fontSize: 11, color: 'var(--text3)' }}>
          Sakthi Solar Solutions ERP &nbsp;|&nbsp; Developed by Data Systems Intelligence Pvt Ltd
        </div>
      </div>
    </div>
  );
}
